import { Radio } from "antd";
import _ from "lodash";
import QueryString from "qs";
import { FC, useEffect, useState } from "react";
import { BsQuestionCircle } from "react-icons/bs";
import { TbMoodCry, TbMoodHappy } from "react-icons/tb";
import { useLocation } from "react-router-dom";
import { getEvaluationDetailItems } from "../../../api/mypage.api";
import useAxios from "../../../hooks/useAxios";
import { IGetEvaluationDetailItems } from "../../../models/mypage.model";
import { IconLevel } from "../../cbt/speaking-test/Evaluation";
import EvaluationBlock from "../../cbt/speaking-test/EvaluationBlock";
import GuideModal from "../../cbt/speaking-test/modals/GuideModal";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";

interface IProps {
  item: any;
  index: number;
  answers: string[];
  onSetAnswer: (e: any, index: number) => void;
  isReadOnly: boolean;
}

const EvaluationItem: FC<IProps> = ({
  item,
  index,
  answers,
  onSetAnswer,
  isReadOnly,
}) => {
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const rubricNo = Number(query.rubricNo);
  const { data: res, isLoading, error, execute } = useAxios<IGetEvaluationDetailItems>();

  const [showGuideVisible, setShowGuideVisible] = useState(false);
  const [scales, setScales] = useState<any>([]);

  useEffect(() => {
    if (item) {
      execute(getEvaluationDetailItems('en', rubricNo, item.evaluationNo));
    }
  }, [item]);

  const getColor = (parentItemName: string) => {
    switch (parentItemName) {
      case 'Content':
      case 'Topic':
      case 'Language Use':
        return '#ffc000';
      case 'Discourse':
      case 'Organization':
        return '#ff0000';
      case 'Delivery':
      case 'Delievery':
      case 'Conventions':
        return '#92d050';
      case 'Production':
        return 'darkgray';
      case 'Physical Expression':
        return 'dimgray';
      default:
        return 'gray';
    }
  };

  const onShowGuide = () => {
    const _scales: any = [];
    res?.data?.evaluationDetailItems?.forEach((item: any) => {
      const scale = {
        descriptionEng: item.scaleComment,
        descriptionKor: item.scaleCommentKr,
      }
      _scales.push(scale);
    });
    setScales(_scales);
    setShowGuideVisible(true);
  }

  return (
    <EvaluationBlock className="mb-4">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className="rubric-content">
        <div
          className="d-flex flex-row title"
          style={{
            borderColor: getColor(item.parentItemName),
            flexWrap: 'nowrap',
          }}
        >
          <div
            className="category px-2"
            style={{ background: getColor(item.parentItemName), display: 'flex', alignItems: 'center' }}
          >
            {item.evaluationItemName}
          </div>
          <div className="title-content">
            {item.rubricName}
          </div>
        </div>
        <div className="d-flex align-items-center mt-3 mb-3 justify-content-around">
          <div
            className="d-flex flex-column justify-content-center align-items-center mr-3 pointer"
            onClick={onShowGuide}
          >
            <BsQuestionCircle color={getColor(item.parentItemName)} />
            <p
              className="mb-0"
              style={{ color: getColor(item.parentItemName) }}
            >
              Guide!
            </p>
          </div>
          <IconLevel
            color={getColor(item.parentItemName) as string}
            label={item.bonusYn === 'Y' ? 'No bonus' : 'Poor'}
            icon={<TbMoodCry className="mr-3" />}
          />
          <div className="w-50 auth-radio__area">
            <Radio.Group
              className="d-flex justify-content-between"
              value={answers[index]}
              onChange={(e) => onSetAnswer(e, index)}
            >
              {
                item.bonusYn === 'Y'
                  ? (
                    <Radio
                      value={`${item.evaluationNo}-n`}
                      disabled={isReadOnly}
                    >
                      0
                    </Radio>
                    )
                  : null
              }
              {_.sortBy(res?.data?.evaluationDetailItems, 'orderSeq').reverse().map((subitem, subindex) => (
                <Radio
                  key={`${index}-${subindex}`}
                  value={`${item.evaluationNo}-${subitem.scaleCode}`}
                  disabled={isReadOnly}
                >
                  {subitem.srtScore}
                </Radio>
              ))}
            </Radio.Group>
          </div>
          <IconLevel
            color={getColor(item.parentItemName) as string}
            label={item.bonusYn === 'Y' ? 'Bonus' : 'Excellent'}
            icon={<TbMoodHappy className="mr-3" />}
          />
        </div>
      </div>

      {showGuideVisible &&
        <GuideModal
          color={getColor(item.parentItemName)}
          visible={showGuideVisible}
          data={scales}
          onCancel={() => setShowGuideVisible(false)}
        />
      }
    </EvaluationBlock>
  );
}

export default EvaluationItem;
